module.exports = __webpack_public_path__ + "static/media/andrew-reduced.5a77eec2.webp";